// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record, List } from "immutable"

import MultiPlace from "./MultiPlace"
import { createAnytime } from "./SearchDate/utils"
import SearchPlace from "./SearchPlace"
import type { SearchDate } from "./SearchDate/SearchDate"

const MulticityFormDataRecord = Record({
  outboundDate: createAnytime(true),
  origin: new MultiPlace({
    places: List([new SearchPlace({ mode: "anywhere", isDefault: true })]),
  }),
  destination: new MultiPlace({
    places: List([new SearchPlace({ mode: "anywhere", isDefault: true })]),
  }),
  joinDestinationWithNext: false,
})

export default class MulticityFormData extends MulticityFormDataRecord {
  // @ts-expect-error: Flow to TS migration.
  outboundDate: SearchDate

  // @ts-expect-error: Flow to TS migration.
  origin: MultiPlace

  // @ts-expect-error: Flow to TS migration.
  destination: MultiPlace

  // @ts-expect-error: Flow to TS migration.
  joinDestinationWithNext: boolean

  crossesDateLine(): boolean {
    const originGeo = this.origin.getGeo()
    const destinationGeo = this.destination.getGeo()
    return Boolean(
      originGeo && destinationGeo && Math.abs(originGeo.lng - destinationGeo.lng) > 180,
    )
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any
  static fromPlainJS(plain: any): MulticityFormData {
    return new MulticityFormData({
      ...plain,
      origin: MultiPlace.fromPlainJS(plain.origin),
      destination: MultiPlace.fromPlainJS(plain.destination),
      outboundDate: plain.outboundDate,
    })
  }
}
